function alertBanner() {
  const alertBanner = document.querySelector('.alert-banner');
  const closeBtn = document.querySelector('.alert-banner-close');
  const today = alertBanner ? alertBanner.getAttribute('data-today') : false;
  const dateClicked = localStorage.getItem('dateClicked');
  const event = new Event('alertBanner');

  if (alertBanner && closeBtn) {
    closeBtn.addEventListener('click', function() {
      localStorage.setItem('dateClicked', today);
      alertBanner.classList.remove('visible');
      window.dispatchEvent(event);
    });

    if (!dateClicked || dateClicked !== today) {
      alertBanner.classList.add('visible');
      window.dispatchEvent(event);
    }
  }
}

export default alertBanner;